/**
 * Разбор булевого флага из строкового env.
 *
 * ВАЖНО: `z.coerce.boolean()` использовать нельзя — он делает Boolean(val), и
 * любая непустая строка (включая "false", "0") становится true. Истиной считаем
 * ТОЛЬКО "true"/"1" (регистр и пробелы не важны), остальное — ложь.
 *
 * Вынесено в отдельный чистый модуль (а не в env.ts), чтобы unit-тест мог
 * импортировать функцию, не запуская при этом bootstrap-парс env.ts
 * (тот падает при отсутствии VITE_API_BASE_URL — CANON SP1 fail-fast).
 */
export function parseEnvBool(val: unknown): boolean {
  if (typeof val === 'string') {
    return ['true', '1'].includes(val.trim().toLowerCase());
  }
  return val === true;
}
